import { render, staticRenderFns } from "./PrivateMessageItem.vue?vue&type=template&id=a979455a&"
import script from "./PrivateMessageItem.vue?vue&type=script&lang=js&"
export * from "./PrivateMessageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports